// services/unitsService.js
import api from './api';

/**
 * Получение единиц измерения веса
 * @returns {Promise<Array>} Массив единиц измерения веса
 */
export const getWeightUnits = async () => {
  try {
    const response = await api.get('/units/weight');
    return response.data;
  } catch (error) {
    console.error('Error fetching weight units:', error);
    throw error;
  }
};

/**
 * Получение единиц измерения объема
 * @returns {Promise<Array>} Массив единиц измерения объема
 */
export const getVolumeUnits = async () => {
  try {
    const response = await api.get('/units/volume');
    return response.data;
  } catch (error) {
    console.error('Error fetching volume units:', error);
    throw error;
  }
};

/**
 * Получение всех единиц измерения
 * @returns {Promise<Object>} Объект с единицами измерения веса и объема
 */
export const getAllUnits = async () => {
  try {
    const [weightUnits, volumeUnits] = await Promise.all([
      getWeightUnits(),
      getVolumeUnits()
    ]);

    return {
      weight: weightUnits,
      volume: volumeUnits
    };
  } catch (error) {
    console.error('Error fetching all units:', error);
    throw error;
  }
};

/**
 * Получение названия единицы измерения веса по значению
 * @param {number|string} value - Значение единицы измерения (число или строка enum)
 * @returns {string} Название единицы измерения
 */
export const getWeightUnitDisplayName = (value) => {
  // Маппинг числовых значений
  const weightUnits = {
    1: 'г (грамм)',
    2: 'кг (килограмм)',
    3: 'фунт',
    4: 'унция'
  };

  // Маппинг строковых значений enum из бэкенда
  const weightUnitsEnum = {
    'Gram': 'г (грамм)',
    'Kilogram': 'кг (килограмм)',
    'Pound': 'фунт',
    'Ounce': 'унция'
  };

  // Если передана строка, используем маппинг enum
  if (typeof value === 'string') {
    return weightUnitsEnum[value] || 'Неизвестная единица';
  }

  // Если передано число, используем числовой маппинг
  return weightUnits[value] || 'Неизвестная единица';
};

/**
 * Получение названия единицы измерения объема по значению
 * @param {number|string} value - Значение единицы измерения (число или строка enum)
 * @returns {string} Название единицы измерения
 */
export const getVolumeUnitDisplayName = (value) => {
  // Маппинг числовых значений
  const volumeUnits = {
    1: 'мл (миллилитр)',
    2: 'л (литр)',
    3: 'жид. унция',
    4: 'галлон',
    5: 'м³ (кубический метр)'
  };

  // Маппинг строковых значений enum из бэкенда
  const volumeUnitsEnum = {
    'Milliliter': 'мл (миллилитр)',
    'Liter': 'л (литр)',
    'FluidOunce': 'жид. унция',
    'Gallon': 'галлон',
    'CubicMeter': 'м³ (кубический метр)'
  };

  // Если передана строка, используем маппинг enum
  if (typeof value === 'string') {
    return volumeUnitsEnum[value] || 'Неизвестная единица';
  }

  // Если передано число, используем числовой маппинг
  return volumeUnits[value] || 'Неизвестная единица';
};

export default {
  getWeightUnits,
  getVolumeUnits,
  getAllUnits,
  getWeightUnitDisplayName,
  getVolumeUnitDisplayName
};